import BaseDataProvider from '../../core/BaseDataProvider';
import _ from 'lodash';
import { Country } from '../../models/BaseModels';

class UtilsDataProvider extends BaseDataProvider {

	getCountriesList() {
		return this.get('/api/v1/countries/').then(data => _.map(data, Country.fromJSON.bind(Country)));
	}

	getUserGroups() {
		return this.get('/api/v1/user_groups/')
			.then(data => _.map(data, item => ({
				id: item.id,
				name: item.name
			})));
	}

	sendErrorReport(email, message) {
		let string = 'Unknown error';
		if(!_.isString(message)) {
			try {
				string = JSON.stringify(message);
			} catch (_e) {
				// Ignore JSON stringify errors
			}
		} else {
			string = message;
		}
		return this.post('/api/v1/error_report/', {email, message: string}, false);
	}

	createUserAction(data) {
		return this.post('/api/v1/admin/user_actions/', data);
	}

	getItemsFromURL(apiURL, searchParam, search) {
		return this.get(`${apiURL}&${searchParam}=${search}`);
	}

	getItemsFromURLWithCustomToken(apiURL, token) {
		return this.getWithCustomToken(`${apiURL}`, token);
	}

	getAITopicNames(topicIds) {
		return this.post('/api/v1/explore/ai-topics-map/', { topics: topicIds });
	}

	refreshGAdsAccount(accountID) {
		return this.post('/api/v1/oauth/refresh_account/', { 'account_id': accountID });
	}
}

const provider = new UtilsDataProvider();
export default provider;
